const defaultText = {
  title: 'FAQs',
  accordion: {
    'item-1': {
      header: 'How does the printer upgrade process work?',
      content:
        'After two years (three years with HP Smart Tank printers), you can upgrade to one of HP’s latest models without paying a cancellation fee. Simply choose your new printer, and we’ll deliver it within 2 business days. Once your new printer is set up, use the prepaid shipping label to return your old one. If you prefer not to upgrade, you can keep your current printer and continue your plan as usual.'
    },
    'item-2': {
      header: 'Is there a trial period for Upgrades?',
      content:
        'Yes. You can try an upgraded printer model for 30-days with no upfront costs. If you decide to cancel your upgrade within 30 days, return your upgrade printer to avoid fees. If you do not return the upgrade printer within 10 days of cancellation, you will be charged an unreturned printer fee. You may cancel your plan on the HP dashboard or by contacting 24/7 live support at 1-888-447-0148. Note: you will be unable to revert back to your original All-In Plan after upgrading.'
    },
    'item-3': {
      header: 'Can I cancel my upgrade after the 30-day trial period?',
      content:
        'Yes, you can cancel your HP All-In Plan anytime. You may cancel your plan on the HP dashboard or by contacting 24/7 live support at 1-888-447-0148. Cancelling your plan will end your ability to print, and you are required to return the printer and ink supplies to HP. A cancellation fee applies if you cancel after the first 30 days and within the first two years (three years for HP Smart Tank printers): [insert table] Cancellation fees listed are calculated from the date you enrolled in the upgrade. Note that cancelling your Upgrade means cancelling your HP All-In Plan subscription altogether. You cannot revert to your original HP All-In Plan after upgrading.'
    },
    'item-4': {
      header: 'Am I required to upgrade my HP All-In plan?',
      content:
        'No. Upgrading is a choice. If you don’t want to upgrade, you can always keep your current printer and continue your plan as is.'
    },
    'item-5': {
      header: 'Do I have a time limit to upgrade my HP All-in plan?',
      content:
        'No. Once you have passed two years on your All-In Plan (three years for Smart Tank printers) you can upgrade at any time as long as your account is in good standing.'
    },
    'item-6': {
      header: 'Do I need to return my current printer if I upgrade?',
      content:
        'Yes. You must return your existing printer using the prepaid shipping label provided by HP - even if you later cancel your upgrade.'
    },
    'item-7': {
      header: 'Can I upgrade to a different printer model than the one I have?',
      content: 'Yes. You can choose from one of HP’s latest printer models.'
    },
    'item-8': {
      header: 'Do I choose a new print plan when upgrading to a new printer?',
      content:
        "No. To keep it simple, when you upgrade, your ink and paper plan will automatically be updated to the closest matching plan for your new printer. If you'd like to change your plan, you can do so anytime - before or after upgrading - from your My Account page."
    },
    'item-9': {
      header: 'How long will it take for my new printer to arrive?',
      content:
        'We aim to deliver your upgraded HP All-In Plan printer within 2 business days after your order is placed (if submitted before 2:30 PM ET, Monday-Friday). Shipping times may vary.'
    },
    'item-10': {
      header: 'How long can I keep using my current printer?',
      content:
        'Continue to use your current printer until your new printer arrives and is set up. Note: once your upgrade is placed, ink [and paper] will only be replaced on the new printer, so set it up promptly to continue enjoying your subscription benefits.'
    },
    'item-11': {
      header: 'Will my monthly fee change if I upgrade my printer?',
      content:
        'Your new monthly fee is calculated depending on the upgrade printer you choose. The new monthly fee starts once you enroll in the upgrade.'
    }
  }
};

export const getDefaultText12 = (key: keyof typeof defaultText) => {
  return defaultText[key];
};

export const getDefaultText = (key: string) => {
  return defaultText[key as keyof typeof defaultText];
};
